import { APPLICATION_NAME } from "../../util/constants";

export const ROUTE_KEYS = {
  HOME: "home",
  LOGIN: "login",
  LOGOUT: "logout",
  FORMS: "forms",
  FOREIGN_GIFTS: "foreignGifts",
  FOREIGN_CONTRACTS: "foreignContracts",
  NOT_FOUND: "notFound",
  ADMIN: 'admin',
  SESSION_MGT: 'SESSION_MGT',
  UNAUTH: 'unauthorized',
  SUBMISSIONS: 'submissions',
  PREVIEW: 'preview',
};

export const FORM_TYPES = { //always expected to be lower case on client and upper case on backend
  FOREIGN_GIFTS: "gifts",
  FOREIGN_CONTRACTS: "contracts",
}

export const FORM_TYPE_LABELS = {
  [FORM_TYPES.FOREIGN_GIFTS]: "Foreign Gifts",
  [FORM_TYPES.FOREIGN_CONTRACTS]: "Foreign Contracts",
}

export const ROUTES = {
  [ROUTE_KEYS.HOME]: {
    path: "/",
    title: APPLICATION_NAME,
  },
  [ROUTE_KEYS.UNAUTH]: {
    path: "/unauthorized",
    title: "Not authorized to see this page",
  },
  [ROUTE_KEYS.LOGIN]: {
    path: "/login",
    title: "Log In",
  },
  [ROUTE_KEYS.LOGOUT]: {
    path: "/logout",
    title: "Log Out",
  },
  [ROUTE_KEYS.FORMS]: {
    path: "/forms",
    params: ":type?/:id?",
    types: Object.values(FORM_TYPES)
  },
  [ROUTE_KEYS.SUBMISSIONS]: {
    path: "submissions",
    title: "Submissions",
  },
  [ROUTE_KEYS.ADMIN]: {
    path: "/admin",
    title: "Admin",
  },
  [ROUTE_KEYS.SESSION_MGT]: {
    path: "manage-sessions",
    title: "Manage Sessions",
  },
  [ROUTE_KEYS.PREVIEW]: {
    path: "periods",
    params: ':year/:period/:formType',
    title: "Preview",
  },
  [ROUTE_KEYS.NOT_FOUND]: {
    path: "/*",
    title: "Page Not Found",
  },
};

export const authenticatedPathNames = {
  login: ROUTE_KEYS.LOGIN,
  logout: ROUTE_KEYS.LOGOUT,
};

const mapFormTypeToRoutes = (formType) => {
  const root = ROUTES[ROUTE_KEYS.FORMS].path
  const path = root + "/" + formType
  const title = FORM_TYPE_LABELS[formType]
  return {
    path: path.startsWith("/") ? path : ("/" + path),
    title
  }
}

const formatted = Object.values(FORM_TYPES).map(mapFormTypeToRoutes)

export const FORM_PATHS = formatted.filter(o => o.path && o.title)